module.exports = __webpack_public_path__ + "static/media/Element_5_treatments.615e2fd2.svg";